import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiErrorMessage, useAuth } from "@/AuthContext";
import { REGISTER } from "@/constants/testIds/auth";
import PublicFooter from "@/components/PublicFooter";

export default function RegisterPage() {
  const { user, loading, register } = useAuth();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user) {
    return <Navigate to={user.has_access ? "/install" : "/billing?subscribe=1"} replace />;
  }

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    setBusy(true);
    try {
      await register({ email, password, full_name: fullName || undefined });
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mp-auth">
      <div className="mp-auth-card">
        <p className="mp-kicker">MinutePay</p>
        <h1>Create account</h1>
        <p className="mp-lead">Start your 7-day free trial. Payment method required. You won&apos;t be charged today.</p>
        <form onSubmit={onSubmit} className="mp-form">
          <label>
            Full name
            <Input
              data-testid={REGISTER.nameInput}
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              autoComplete="name"
            />
          </label>
          <label>
            Email
            <Input
              data-testid={REGISTER.emailInput}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </label>
          <label>
            Password
            <Input
              data-testid={REGISTER.passwordInput}
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
          </label>
          {error ? <p className="mp-error">{error}</p> : null}
          <Button data-testid={REGISTER.submitButton} type="submit" disabled={busy} className="w-full">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="mp-switch">
          Already have an account?{" "}
          <Link data-testid={REGISTER.loginLink} to="/login">
            Sign in
          </Link>
        </p>
      </div>
      <PublicFooter />
    </div>
  );
}
